module.exports = __webpack_public_path__ + "img/kommune-239.372d34e6.svg";